var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 2a.75.75 0 010 1.5h-1.5v5.086c0 .464-.184.91-.513 1.237l-2 2-.032.04a.25.25 0 000 .275l.032.039 2 2c.329.328.513.773.513 1.237V20.5h1.5a.75.75 0 010 1.5H4.75a.75.75 0 010-1.5h1.5v-5.086c0-.406.141-.798.396-1.11l.117-.127 2-2a.25.25 0 000-.354l-2-2a1.75 1.75 0 01-.513-1.237V3.5h-1.5a.75.75 0 010-1.5h14.5zM7.75 8.586c0 .066.026.13.073.177l2 2a1.75 1.75 0 010 2.474l-2 2-.031.038a.25.25 0 00-.042.14v.688c.934.44 2.259.921 3.75.224 1.992-.93 3.633-.748 4.75-.34v-.573a.25.25 0 00-.073-.177l-2-2a1.75 1.75 0 010-2.474l2-2a.25.25 0 00.073-.177V3.5h-8.5v5.086z",
    fill: "currentColor"
  })));
}
SvgTimeOut.displayName = 'TimeOut';
export default SvgTimeOut;